import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTargetForm from '../../../components/forms/ExerciseTargetForm';
import { useExerciseTargetApi } from '../../../hooks/useExerciseTargetApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseTargetDTO } from '../../../services/apiClient';

const ExerciseTargetCreate: React.FC = () => {
  const { create, isLoading } = useExerciseTargetApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Targets', href: '/admin/exercisetargets' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ExerciseTargetDTO) => {
    try {
      await create(data);
      navigate('/admin/exercisetargets');
    } catch (error) {
      console.error('Error creating Exercise Target:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetargets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseTarget.Edit'
    >
        <ExerciseTargetForm
          initialValues={{} as ExerciseTargetDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/exercisetargets')}
        />
    </AdminLayout>
  );
};

export default ExerciseTargetCreate;